var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaitingRoom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.9609 60.0156V71.7891H5.03906V60.0156H0V72.8041C0 76.5973 2.49887 79.8173 5.93652 80.9061V86.0001H10.9756V81.3011H75.0244V86.0001H80.0635V80.9061C83.5011 79.8173 86 76.5973 86 72.8041V60.0156H80.9609Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6213 66.8195V66.75V47.7949C28.6213 44.8759 26.255 42.5098 23.3362 42.5098H15.396C12.477 42.5098 10.1108 44.8761 10.1108 47.7949V66.75V66.8195H28.6213Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3391 66.8195V66.75V47.7949C52.3391 44.8759 49.9728 42.5098 47.054 42.5098H38.9458C36.0268 42.5098 33.6606 44.8761 33.6606 47.7949V66.75V66.8195H52.3391Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8889 66.8195V66.75V47.7949C75.8889 44.8759 73.5226 42.5098 70.6038 42.5098H62.6636C59.7446 42.5098 57.3784 44.8761 57.3784 47.7949V66.75V66.8195H75.8889Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43 29.7723C51.2083 29.7723 57.8861 23.0944 57.8861 14.8862C57.8861 6.67793 51.2083 0 43 0C34.7917 0 28.1138 6.67793 28.1138 14.8862C28.1138 23.0944 34.7917 29.7723 43 29.7723ZM40.4805 14.9786V7.05889H45.5195V17.3502L39.4622 22.5772L36.2503 18.6944L40.4805 14.9786Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingRoom);
export default __webpack_public_path__ + "static/media/waiting-room.967d32ae2f5ba2cde349bc4e60732e48.svg";
export { ForwardRef as ReactComponent };